"use client"
import { useServicesLinks } from './Nav/links'
import WhatWeOfferCard from './WhatWeOfferCard'
import { useTranslations } from 'next-intl'

type Props = {
  className: string
}

const WhatWeOffer = ({ className }: Props) => {
  const  t  = useTranslations()
  const servicesLinks = useServicesLinks()
  return (
    <div className={className}>
      <div className='text-center'>
        <p className='uppercase rtl:text-base rtl:font-semibold'>
          {t('homePage.services')}
        </p>
        <h3 className='mx-auto my-5 sm:w-1/2 text-3xl sm:text-4xl font-bold'>
          {t('homePage.weAreOffering')}
        </h3>
        <div className='relative mx-auto h-1 w-24 rounded bg-orange before:absolute before:-top-1 before:h-3 before:w-3 before:animate-load before:rounded-full before:bg-orange' />
      </div>
      <div>
        <div className='flex flex-wrap justify-center gap-5 bg-lightGrey py-10'>
          {servicesLinks.map((link, index) => (
            <div key={index}>
              <WhatWeOfferCard
                description={link.description}
                title={link.title}
                url={link.url}
                img={link.img}
                className='shadow-sm hover:shadow-lg'
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default WhatWeOffer
